// src/hooks/hotelRatings/useRestoreAllHotelRatings.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllHotelRatings as restoreAllHotelRatingsAPI } from "../../api/apiHotelRatings";
import parseError from "../../utils/parseError";

const useRestoreAllHotelRatings = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAll, isPending: isRestoreAll } = useMutation({
        mutationFn: restoreAllHotelRatingsAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected hotel ratings restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRatings"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore selected hotel ratings");
        },
    });

    return { restoreAllHotelRatings: restoreAll, isRestoreAll };
};

export default useRestoreAllHotelRatings;
